import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fb622728&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fb622728&prod&scoped=true&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=fb622728&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb622728",
  null
  
)

export default component.exports